"use client";

import CTABanner from "@/components/CTABanner";
import Footer from "@/layout/Footer";
import Header from "@/layout/Header";

export default function PublicLayout({
	children,
}: {
	children: React.ReactNode;
}) {
	return (
		<>
			<Header />
			<main>{children}</main>
			<CTABanner />
			<Footer />
		</>
	);
}
